import React from 'react';

//0 pendiente
//1 realizado
const EstadoTarea = ( props ) => {
  //console.log("props");
  //console.log(props);
  let valor = parseInt(props.value)
  return (
    <div>
      { valor===0?
        <span className="badge badge-secondary">No</span>
        :
        <span className="badge badge-success">SI</span>
      }
    </div>
  );
};

//-------------------------------------

export default (EstadoTarea);
